import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(text: string, length: number = 10, end: string = '...'): string {
    if (isNaN(length)) {
      length = 10;
    }

    if (end === undefined) {
      end = '...';
    }

    if (text === undefined) {
      text = '';
    }

    if (_.get(text, 'length', 0) <= length) {
      return text;
    } else {
      return String(text).substring(0, length) + end;
    }
  }
}
